/**
 * Censor an email address to protect privacy
 * @param {string} email - Email address to censor
 * @returns {string} Censored email address
 */
export const censorEmail = (email) => {
  if (!email) return '-';
  
  // Split the email at the @ symbol
  const [username, domain] = email.split('@');
  
  // If the username is 1-2 characters, show only the first character
  // If it's 3-4 characters, show the first and last
  // If it's 5+ characters, show the first two and last two
  let censoredUsername;
  if (username.length <= 2) {
    censoredUsername = username.charAt(0) + '***';
  } else if (username.length <= 4) {
    censoredUsername = username.charAt(0) + '***' + username.charAt(username.length - 1);
  } else {
    censoredUsername = username.substring(0, 2) + '***' + username.substring(username.length - 2);
  }
  
  // For the domain, show the first character of each part
  const domainParts = domain.split('.');
  const censoredDomain = domainParts.map(part => 
    part.charAt(0) + '*'.repeat(part.length - 1)
  ).join('.');
  
  return `${censoredUsername}@${censoredDomain}`;
};

/**
 * Format bytes to a human-readable string with appropriate units
 * @param {number} bytes - Number of bytes to format
 * @param {number} decimals - Number of decimal places to show (default: 2)
 * @returns {string} Formatted string with appropriate unit
 */
export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};
